import React from 'react';
import PropTypes from 'prop-types';

import RadioSwatch from '../RadioSwatch/RadioSwatch';
import { StyledUl, StyledLi } from './CollectionsListFilterStyles';

var CollectionsListFilter = function CollectionsListFilter(_ref) {
  var filters = _ref.filters,
      activeFilter = _ref.activeFilter,
      handleFilterChange = _ref.handleFilterChange;

  return React.createElement(
    StyledUl,
    null,
    filters.map(function (_ref2) {
      var colorValue = _ref2.colorValue;
      return React.createElement(
        StyledLi,
        { key: colorValue },
        React.createElement('input', {
          id: colorValue,
          type: 'checkbox',
          'aria-label': 'Toggle ' + colorValue + ' filter',
          onChange: handleFilterChange,
          value: colorValue,
          defaultChecked: colorValue === activeFilter
        }),
        React.createElement(RadioSwatch, {
          value: colorValue,
          active: colorValue === activeFilter,
          htmlFor: colorValue,
          optionAvailable: true
        })
      );
    })
  );
};

CollectionsListFilter.propTypes = {
  handleFilterChange: PropTypes.func,
  filters: PropTypes.array.isRequired,
  activeFilter: PropTypes.string
};

export default CollectionsListFilter;